$(document).ready(function() 
{
    function $setThumbnailContainerHeight() 
    {
        var mobile_media_query = window.matchMedia("(max-width: 767.98px)");

        if (mobile_media_query.matches)
        {
            $('.thumbnails').css({"height": "auto", "overflowY": "scroll"});
        }
        else 
        {
            console.log('No Match!');
            $mainImageHeight = $('.main-image').css("height");
            $mainImageHeightFloat = parseFloat($mainImageHeight);
            $('.thumbnails').css({"height": $mainImageHeightFloat, "overflowY": "scroll"});
        }
    };

    $setThumbnailContainerHeight();

    $(window).on( "resize", function() {
        $setThumbnailContainerHeight();
    });

    var scrolltopvalue = 0;
    $thumbnailScrollTop = $('.thumbnails').scrollTop();
    $('.thumbnail-arrow-up').hide();


    function $hideArrowFewThumbnails() {
      
      let thumbnailsContainer = document.querySelector('.thumbnails');
      let thumbnailBoundingRect = thumbnailsContainer.getBoundingClientRect();
      let thumbnailBoundingRectY = thumbnailBoundingRect.y;
      let thumbnailBoundingRectBottom = thumbnailBoundingRect.bottom;
      console.log('container bottom');
      console.log(thumbnailBoundingRectBottom);
      
      let thumbnailImageList = document.querySelectorAll('.thumbnail.thumbnail--media-image.visible');
      let finalThumbnailImage = thumbnailImageList[thumbnailImageList.length - 1];
      console.log(finalThumbnailImage);
      let finalThumbnailImageBoundingRect = finalThumbnailImage.getBoundingClientRect();
      console.log(finalThumbnailImageBoundingRect);
      let finalThumbnailImageBoundingRectBottom = finalThumbnailImageBoundingRect.bottom;
      console.log('final image bottom');
      console.log(finalThumbnailImageBoundingRectBottom);

      if (thumbnailBoundingRectBottom >   finalThumbnailImageBoundingRectBottom) {
        $('.thumbnail-arrow-down').hide();
      } else {
        $('.thumbnail-arrow-down').show();
      }
    }

    setTimeout($hideArrowFewThumbnails(), 5000);

    
    $('.thumbnails').on("scroll", function() {

      let thumbnailsContainer = document.querySelector('.thumbnails');
      let thumbnailBoundingRect = thumbnailsContainer.getBoundingClientRect();
      let thumbnailBoundingRectY = thumbnailBoundingRect.y;
      let thumbnailBoundingRectBottom = thumbnailBoundingRect.bottom;
  
      let firstThumbnailImage = document.querySelector('.thumbnail.thumbnail--media-image.visible');
      let firstThumbnailImageBoundingRect = firstThumbnailImage.getBoundingClientRect();
      let firstThumbnailImageBoundingRectY = firstThumbnailImageBoundingRect.y;
  
      let thumbnailImageList = document.querySelectorAll('.thumbnail.thumbnail--media-image.visible');
      let finalThumbnailImage = thumbnailImageList[thumbnailImageList.length - 1];
      let finalThumbnailImageBoundingRect = finalThumbnailImage.getBoundingClientRect();
      let finalThumbnailImageBoundingRectBottom = finalThumbnailImageBoundingRect.bottom;
      let finalThumbnailImageBoundingRectBottomAdjusted = finalThumbnailImageBoundingRectBottom - 20;
      
      if (thumbnailBoundingRectY == firstThumbnailImageBoundingRectY) {
        $('.thumbnail-arrow-up').hide();
      } else {
        $('.thumbnail-arrow-up').show();
      }

      if (thumbnailBoundingRectBottom > finalThumbnailImageBoundingRectBottomAdjusted) {
        $('.thumbnail-arrow-down').hide();
      } else {
        $('.thumbnail-arrow-down').show();
      }

    });

    $('.opt-label').on("click", function (){
      console.log('clicked');
      setTimeout($hideArrowFewThumbnails, 300);
      console.log('run');
    });
    
    
    $('.thumbnail-arrow-down').on("click", function() {
      scrolltopvalue += 150;
      $('.thumbnails').css({"scroll-behavior": "smooth"});
      $('.thumbnails').scrollTop(scrolltopvalue);
    });

    $('.thumbnail-arrow-up').on("click", function() {
      scrolltopvalue -= 150;
      $('.thumbnails').css({"scroll-behavior": "smooth"});
      $('.thumbnails').scrollTop(scrolltopvalue);
    });
    

  });